import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Grid, Spacer } from '@zillow/constellation';
import { Text } from '@zillow/constellation-10';

import AppSelectors from '../../../../../selectors/AppSelectors';
import TourCardSelectable from '../../../../postingPath/TourCardSelectable';
import EmptyTours from '../EmptyTours';

const propTypes = {
  vrModels: PropTypes.arrayOf(
    PropTypes.shape({
      vrModelId: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      createDateTimeUtc: PropTypes.string.isRequired,
      creatorName: PropTypes.string.isRequired,
      posterUrl: PropTypes.string,
      tourUrl: PropTypes.string,
      status: PropTypes.oneOf(['published', 'unpublished']),
    }),
  ),
  onSelectTour: PropTypes.func.isRequired,
  onViewTour: PropTypes.func.isRequired,
  tourType: PropTypes.oneOf(['floorPlan', 'unit', 'amenity', 'singleFamily']),
  selectedVrModelId: PropTypes.string,
};

const defaultProps = {
  vrModels: [],
  tourType: 'floorPlan',
  selectedVrModelId: undefined,
};

const HELPER_TEXT = {
  floorPlan: 'Select a tour to showcase this floor plan.',
  unit: 'Select a tour to showcase this unit.',
  singleFamily: 'Only one 3d tour can be selected per property.',
};

const ROW_SIZE = 2;

const ZillowTours = ({ vrModels, onSelectTour, onViewTour, tourType, selectedVrModelId }) => {
  const isScreenMobile = useSelector((state) => AppSelectors.makeIsScreenMobile(state));

  if (vrModels.length === 0) {
    return <EmptyTours />;
  }

  const vrModelChunks = [];
  for (let i = 0; i < vrModels.length; i += ROW_SIZE) {
    vrModelChunks.push(vrModels.slice(i, i + ROW_SIZE));
  }

  return (
    <Spacer padding="sm">
      {HELPER_TEXT[tourType] && (
        <Text css={{ paddingBottom: '200' }} asChild>
          <p>{HELPER_TEXT[tourType]}</p>
        </Text>
      )}
      {vrModelChunks.map((vrModelChunk, chunkIndex) => (
        <Grid
          display="grid"
          gridTemplateColumns={isScreenMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'}
          gridGap="sm"
          paddingY="xs"
          key={`tour-Flex-${chunkIndex}`}
        >
          {vrModelChunk.map((vrModel, vrModelIndex) => (
            <Grid
              key={vrModel.vrModelId}
              gridColumnStart={!isScreenMobile && vrModelIndex % 2 ? '2' : '1'}
              gridColumnEnd="span 1"
            >
              <TourCardSelectable
                vrModel={vrModel}
                isSelected={vrModel.vrModelId === selectedVrModelId}
                onView={() => onViewTour(vrModel)}
                onSelect={() => onSelectTour(vrModel.vrModelId)}
              />
            </Grid>
          ))}
        </Grid>
      ))}
    </Spacer>
  );
};

ZillowTours.propTypes = propTypes;
ZillowTours.defaultProps = defaultProps;

export default ZillowTours;
